import src from "IMAGE";
export default { src, width: 226, height: 427, blurWidth: 0, blurHeight: 0};
